import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { ModuleFlagsService } from '@shared-lib/services/module-flags.service';
import { KeycloakInitService } from '../auth-services/keycloak-init.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private readonly moduleFlags: ModuleFlagsService,
    private readonly access: KeycloakInitService,
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
      return false;
    }

    if (route.data?.['defaultEntry'] === true) {
      return this.router.parseUrl(this.access.getFirstAllowedRoute() ?? '/access-denied');
    }

    await Promise.all([
      this.moduleFlags.load(),
      this.access.loadAuthenticatedUserPermissions(),
    ]);

    const accessKey = String(route.data?.['accessKey'] ?? route.routeConfig?.path ?? '');
    const moduleAvailable = this.moduleFlags.isVisible(accessKey) &&
      this.moduleFlags.isActive(accessKey);

    return moduleAvailable && this.access.canAccessRoute(state.url)
      ? true
      : this.router.parseUrl('/access-denied');
  }
}
